export default "__VITE_ASSET__vcjddc$p__"